var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.color)?_c('img',{staticClass:"ico-17 fa-spin",attrs:{"src":require("../assets/icons/spinner.svg")}}):(_vm.color === 'pink')?_c('img',{staticClass:"ico-17 fa-spin",attrs:{"src":require("../assets/icons/spinner_pink.svg")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }